/** Sentinel priority: the optimizer never relaxes this constraint. */
export const UNRELAXABLE_CONSTRAINT_PRIORITY = -1

/** The tier a constraint takes when it carries no priority of its own. */
export const DEFAULT_CONSTRAINT_PRIORITY = 1

export const isValidConstraintPriority = (value: number): boolean =>
  Number.isInteger(value) && value >= UNRELAXABLE_CONSTRAINT_PRIORITY

/**
 * Merge two priority tiers. If either is the unrelaxable sentinel (-1),
 * the result is unrelaxable — a hard constraint never degrades to soft.
 */
export const mergePriority = (a: number, b: number): number =>
  a === UNRELAXABLE_CONSTRAINT_PRIORITY || b === UNRELAXABLE_CONSTRAINT_PRIORITY
    ? UNRELAXABLE_CONSTRAINT_PRIORITY
    : Math.max(a, b)
